import { request } from "utils/api";
import { ReducedUserProfile } from "api/user";

// feedback form from GET /sip/feedback-forms
export interface SipFeedbackForm {
    author?: ReducedUserProfile,
    cancellationReason: string,
    formData: any,
    humidityPercent: number,
    temperatureDegC: number,
    updatedAt: string,
    weatherCondition: "sunny" | "cloudy" | "veryCloudy" | "rainy" | "veryRainy",
}

// aggregated forms from GET /sip/feedback-forms/aggregated
export interface AggregatedSipForms {
    aggregatedFormData: any,
    numManualForms: number,
    numPrefilledForms: number,
    weatherConditions: {
        cloudy: number,
        rainy: number,
        sunny: number,
        veryCloudy: number,
        veryRainy: number,
    },
}

// fetch feedback form (GET /sip/feedback-forms)
export const getFeedbackForm = (data: {
    bookingId: string,
}) => request<SipFeedbackForm>({
    data,
    endpoint: "/sip/feedback-forms",
    method: "get",
});

// update feedback form (PATCH /sip/feedback-forms)
export const patchFeedbackForm = (data: SipFeedbackForm) => request<SipFeedbackForm>({
    data,
    endpoint: "/sip/feedback-forms",
    method: "patch",
});

// export feedback form (GET /sip/feedback-forms/export)
export const exportFeedbackForm = (data: {
    bookingId: string,
}) => request<{ url: string }>({
    data,
    endpoint: "/sip/feedback-forms/export",
    method: "get",
});

// fetch aggregated forms (GET /sip/feedback-forms/aggregated)
export const getAggregatedForms = (data: {
    bookingQuery?: string,
    clubId?: string,
    fromDate?: string,
    toDate?: string,
}) => request<AggregatedSipForms>({
    data,
    endpoint: "/sip/feedback-forms/aggregated",
    method: "get",
});

// export aggregated forms (GET /sip/feedback-forms/aggregated/export)
export const exportAggregatedForms = (data: {
    bookingQuery?: string,
    clubId?: string,
    fromDate?: string,
    toDate?: string,
}) => request<{ url: string }>({
    data,
    endpoint: "/sip/feedback-forms/aggregated/export",
    method: "get",
});

// export sip forms list (GET /sip/feedback-forms/list/export)
export const exportFormsList = (data: {
    bookingQuery?: string,
    clubId?: string,
    fromDate?: string,
    toDate?: string,
}) => request<{ url: string }>({
    data,
    endpoint: "/sip/feedback-forms/list/export",
    method: "get",
});
